module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-aside', {
    staticClass: "main-sidebar",
    class: _vm.expandWidth
  }, [_c('el-menu', {
    attrs: {
      "collapse": _vm.collapse
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-menu-item', {
    staticClass: "logo-item",
    attrs: {
      "data-qa": "SideBar-ProductName-MenuItem",
      "index": "logo"
    }
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/src/assets/img/logo-navbar.png",
      "alt": "Logo"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ExoHome")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/device"
    }
  }, [_c('el-menu-item', {
    class: _vm.showDevicesActive,
    attrs: {
      "data-qa": "SideBar-Devices-MenuItem",
      "index": "/device"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuDevices')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_c('el-menu-item', {
    class: _vm.showUsersActive,
    attrs: {
      "data-qa": "SideBar-Users-MenuItem",
      "index": "/user"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuUsers')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/firmware"
    }
  }, [_c('el-menu-item', {
    class: _vm.showFirmwareActive,
    attrs: {
      "data-qa": "SideBar-Firmware-MenuItem",
      "index": "/firmware"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuFirmware')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/theme"
    }
  }, [_c('el-menu-item', {
    class: _vm.showThemeActive,
    attrs: {
      "data-qa": "SideBar-Theme-MenuItem",
      "index": "/theme"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuTheme')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/informationModel"
    }
  }, [_c('el-menu-item', {
    class: _vm.showIMActive,
    attrs: {
      "data-qa": "SideBar-InformationModel-MenuItem",
      "index": "/informationModel"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuInformationModel')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/notifications"
    }
  }, [_c('el-menu-item', {
    class: _vm.showNotifyActive,
    attrs: {
      "data-qa": "SideBar-Notifications-MenuItem",
      "index": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuNotifications')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/export"
    }
  }, [_c('el-menu-item', {
    class: _vm.showExportActive,
    attrs: {
      "data-qa": "SideBar-Export-MenuItem",
      "index": "/export"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuExport')))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f42a78","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/Sidebar.vue
// module id = 966
// module chunks = 3